import { Component, Input } from '@angular/core';

@Component({
	selector: 'angie-overlay',
	templateUrl: './overlay.component.html',
	styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent {
	@Input() showOverlay: boolean = false;
}
